import { render, staticRenderFns } from "./CoachDetailGallery.vue?vue&type=template&id=0496a305&scoped=true&lang=pug"
import script from "./CoachDetailGallery.vue?vue&type=script&lang=js"
export * from "./CoachDetailGallery.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailGallery.vue?vue&type=style&index=0&id=0496a305&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0496a305",
  null
  
)

export default component.exports